export default __webpack_public_path__ + "static/media/Node.js_-_adamr.space___Codecademy.be839fe3.pdf";